<template>
  <div>
    <donapp-dialog
      v-if="show"
      @close="closeUpload"
      title
      :header="$t('labels.change_cover_img')"
      v-on:submit="cropUpload"
      :disableOk="uploading"
      theme="npo"
      wide
    >
      <div class="text-center">
        <croppa
          :placeholder="$t('labels.choose_img')"
          v-model="croppa"
          @new-image-drawn="onNewImage"
          @zoom="onZoom"
          :width="360"
          :height="360"
          :quality="3"
          :file-size="fileSize"
          :prevent-white-space="true"
        />
        <vue-slider
          :interval="0.001"
          @input="onSliderChange"
          ref="slider"
          v-model="sliderVal"
          :tooltip="false"
          :min="sliderMin"
          :max="sliderMax"
          :disabled="disabled"
        />
        <p>{{$t('labels.upload_cover_img')}}</p>
      </div>
    </donapp-dialog>
    <div>
      <div class="flex status">
        <span class="h4">{{$t('profile.status')}}</span>
        <span :class="statusCircle(npoProfile.status)"/>
      </div>
      <h3>{{$t('labels.qr_code')}}</h3>
      <div class="qr-code-content">
        <div class="qr-code grey-bg clickable">
          <a ref="qrAnchor" download="npoQrCode.jpg" href="#">
            <div class="middle" v-on:click="downloadQrCode">
              <i class="material-icons" v-on:click="downloadQrCode">file_download</i>
            </div>
            <div class="overlay" v-on:click="downloadQrCode"/>
            <QRCanvas ref="qrCodeCanvas" v-show="false" :options="{data: qrCodeLink, size: 1600}"/>
            <QRCanvas :options="{data: qrCodeLink, size: 200}" v-on:click="downloadQrCode"></QRCanvas>
          </a>
        </div>
        <p class="qr-code-info">
          Cliccando sull'immagine puoi scaricare il tuo QrCode
          <br>Stampalo e/o invialo ai tuoi sostenitori.
          <br>Mostrandolo alla cassa degli esercenti Donapp, potranno facilmente donare alla tua non profit.
          <br>
          <b>Donare non è ma stato così facile!</b>
        </p>
      </div>
      <h3>{{$t('labels.cover_img')}}</h3>
      <div
        class="cover-image grey-bg clickable"
        :class="{ 'size-md-bg': !hasImg }"
        :style="{ 'background-image': 'url(' + npoCoverImg + ')' }"
        v-on:click="changePhoto"
      >
        <div class="middle" v-on:click="changePhoto">
          <i class="material-icons" v-on:click="changePhoto">file_upload</i>
        </div>
        <div class="overlay" v-on:click="changePhoto"/>
      </div>
      <h3>{{$t('profile.npo_profile')}}</h3>
      <material-input
        :label="$t('profile.name')"
        name="name"
        v-model="npoProfile.name"
        placeholder="Name"
        class="material-input"
        color="grey"
        :size="20"
        :validation="validation.required"
      />
      <p class="-autocomplete-label">{{$t('profile.description')}}</p>
      <textarea v-model="npoProfile.description" rows="10" class="material-input"></textarea>
      <div class="field material-input field-autocomplete" placeholder="Indirizzo">
        <vue-google-autocomplete
          id="address"
          name="address"
          ref="address"
          class="input"
          placeholder
          :value="npoProfile.address"
          types="address"
          :country="['it']"
          v-on:placechanged="getAddressData"
        ></vue-google-autocomplete>
        <label for="address">{{$t('profile.location')}}</label>
        <div class="baseline"></div>
        <span class="info" :class="{error: addressError}">{{$t('errors.address_required')}}</span>
      </div>
      <material-input
        name="iban"
        :label="$t('profile.iban')"
        v-model="npoProfile.iban"
        placeholder="location"
        class="material-input"
        color="grey"
        :size="20"
        readonly
      />
      <material-input
        name="vat"
        :label="$t('profile.vat')"
        v-model="npoProfile.vat"
        placeholder="vat"
        class="material-input"
        color="grey"
        :size="20"
        :validation="validation.vat"
      />
      <h3>{{$t('profile.contact_info')}}</h3>
      <material-input
        name="firstName"
        :label="$t('profile.first_name')"
        v-model="npoProfile.firstName"
        placeholder="company name"
        class="material-input col-lg-5"
        color="grey"
        :size="20"
        :validation="validation.required"
      />
      <material-input
        name="lastName"
        :label="$t('profile.last_name')"
        v-model="npoProfile.lastName"
        placeholder="company name"
        class="material-input col-lg-5 col-lg-offset-1"
        color="grey"
        :size="20"
        :validation="validation.required"
      />
      <material-input
        name="website"
        :label="$t('profile.website')"
        v-model="npoProfile.website"
        placeholder="company email"
        class="material-input col-lg-5"
        color="grey"
        :size="20"
        :validation="validation.required"
      />
      <material-input
        name="email"
        :label="$t('profile.npo_email')"
        v-model="npoProfile.email"
        placeholder="company email"
        class="material-input col-lg-5 col-lg-offset-1"
        color="grey"
        :size="20"
        :validation="validation.email"
      />
      <material-input
        name="tel"
        :label="$t('profile.tel')"
        v-model="npoProfile.tel"
        placeholder="telephone"
        class="material-input col-lg-5"
        color="grey"
        :size="20"
        :validation="validation.tel"
      />
      <div :style="{ clear: 'both'}"/>
      <donapp-button
        :disabled="$validator.errors.items.length > 0 || loading"
        :text="$t('profile.save')"
        :action="saveNpo"
        class="gradient-npo"
      ></donapp-button>
    </div>
    <div v-if="!loading && error">
      <p>{{error}}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MaterialInput from '@/components/shared/inputs/Material'
import DonappButton from '@/components/shared/buttons/Button'
import DonappDialog from '@/components/shared/Dialog'
import SelectDropDown from '@/components/shared/inputs/SelectDropDown'
import Multiselect from 'vue-multiselect'
import circleStatusClass from '@/mixins/StatusCircle'
import apiService from '@/services/ApiService'
import vueSlider from 'vue-slider-component'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { QRCanvas } from 'qrcanvas-vue'

export default {
  name: 'npo-profile',
  mixins: [circleStatusClass],
  components: {
    MaterialInput,
    DonappButton,
    SelectDropDown,
    Multiselect,
    vueSlider,
    DonappDialog,
    VueGoogleAutocomplete,
    QRCanvas
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  data() {
    return {
      addressError: false,
      npoProfile: {},
      error: undefined,
      loading: false,
      show: false,
      disabled: true,
      fileSize: 102400,
      uploading: false,
      croppa: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      validation: {
        required: 'required|min:2',
        email: 'required|email',
        tel: 'numeric|min:6',
        vat: 'required|min:11|max:16'
      }
    }
  },
  mounted: async function() {
    try {
      this.error = undefined
      this.loading = true
      const { data: result } = await apiService.getProfile('npos', this.npo._id)
      if (result.success) this.npoProfile = result.data
      else this.error = result.error.message
    } catch (error) {
      this.error = error.message || this.$i18n.t('errors.something_wrong')
    }
    this.loading = false
  },
  methods: {
    ...mapActions({
      changeCoverImg: 'changeCoverImg'
    }),
    getAddressData: function(result, place, id) {
      if (result && result.longitude && result.latitude && result.route) {
        this.addressError = false
        this.npoProfile.loc = [result.longitude, result.latitude]
        this.npoProfile.address = result.route
      } else this.addressError = true
    },
    async saveNpo() {
      this.loading = true
      try {
        const { data: result } = await apiService.updateProfile('npos', this.npo._id, this.npoProfile)
        if (result.success) {
          this.npoProfile = result.data
          this.$refs.address.update(this.npoProfile.address)
          this.$toasted.success(this.$i18n.t('messages.profile_updated'))
        } else {
          this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + result.error.message)
        }
      } catch (error) {
        this.$toasted.error(error.message)
      }
      this.loading = false
    },
    changePhoto: function() {
      this.show = true
    },
    downloadQrCode: function(el) {
      console.log(this.$refs.qrCodeCanvas.$el)
      let image = this.$refs.qrCodeCanvas.$el.toDataURL('image/jpg')
      this.$refs.qrAnchor.href = image
    },
    cropSuccess: function() {},
    cropUpload: async function() {
      this.uploading = true
      if (this.uploading) {
        try {
          const blob = await this.croppa.promisedBlob('image/jpeg')
          if (blob) {
            const { data: result } = await this.changeCoverImg({
              type: 'npos',
              profileId: this.npo._id,
              blob
            })
            if (result.success) {
              this.npoProfile = result.data
              // this.npoProfile.category = this.categories.find(category => category.value === result.data.category)
              this.$toasted.success(this.$i18n.t('messages.profile_updated'))
              this.show = false
            } else {
              this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + result.error.message)
            }
          } else {
            this.$toasted.error(this.$i18n.t('errors.something_wrong'))
          }
        } catch (error) {
          this.$toasted.error(error)
        }
        this.uploading = false
      }
    },
    cropUploadFail: function() {},
    cropUploadSuccess: function() {},
    closeUpload: function() {
      this.show = false
    },
    onNewImage() {
      this.sliderVal = this.croppa.scaleRatio
      this.sliderMin = this.croppa.scaleRatio / 2
      this.sliderMax = this.croppa.scaleRatio * 2
      this.disabled = false
    },

    onSliderChange(evt) {
      var increment = evt
      this.croppa.scaleRatio = +increment
      this.height = +increment
    },

    onZoom() {
      this.sliderVal = this.croppa.scaleRatio
    }
  },
  computed: {
    ...mapState({
      npo: state => state.user.loggedRole.npo
    }),
    hasImg: function() {
      return this.npoProfile.cover && this.npoProfile.cover.length > 2
    },
    npoCoverImg: function() {
      return this.hasImg ? this.npoProfile.cover : './static/img/npo.svg'
    },
    qrCodeLink: function() {
      return 'www.donapp.it/qrcodes/npos/?npo=' + this.npoProfile._id
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

.material-input {
  margin-bottom: 17px;
}

.flex.status {
  align-items: center;
}

.field-label {
  color: #aab7c4;
  cursor: default;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 400;
}

.field-label.empty {
  font-size: 14px;
}

h3,
.h3 {
  @include biggestFontSize();
  font-weight: 700;
  line-height: 21px;
  cursor: default;
}

h3 {
  margin: 34px 0 17px;
}

.flex.status .h3 {
  margin-top: 0px;
  margin-bottom: 0px;
}

textarea {
  width: 100%;
  border-color: $dividerGrey;
}

.croppa-container.c1 {
  width: 600px;
  height: 300px;
}

.all-slider {
  max-width: 600px;
}

.cover-image {
  width: 350px;
  height: 350px;
}

.qr-code-content {
  display: flex;
  align-items: center;
}

.qr-code {
  width: 200px;
  height: 200px;
}

.qr-code {
  position: relative;
}

.cover-image {
  border-radius: 8px 8px 8px 8px;
  background-size: cover;
  background-position: center center;
}

.qr-code .overlay {
  position: absolute;
  top: 0px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;

  i {
    color: white;
  }
}

.qr-code .middle {
  position: absolute;
}

.cover-image .middle {
  position: relative;
}

.overlay {
  width: 100%;
  height: 100%;
  background-color: $grey;
  opacity: 0;
}

.cover-image .overlay {
  position: relative;
  margin-top: -50px;
  border-radius: 8px;
  margin-right: 0px;
  margin-bottom: 17px;
  margin-left: 0px;
}

.qr-code-info {
  margin-left: 10px;
  font-size: 16px;
}

.qr-code.clickable:hover,
.cover-image.clickable:hover {
  .middle {
    opacity: 1;
    z-index: 1;
    height: 50px;
  }

  .middle .material-icons {
    font-size: 50px;
  }

  .overlay {
    opacity: 0.6;
  }
}

.field-autocomplete {
  position: relative;
  width: 100%;
  height: 50px;
}

.field-autocomplete.half-width {
  width: 50%;
}

.field-autocomplete.quarter-width {
  width: calc(25% - 10px);
}

.baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 4px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  pointer-events: none;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 6px;
  color: #32325d;
  background-color: transparent;
}

.input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.input:focus,
.input:not(.empty) {
  opacity: 1;
}

.input:focus::-webkit-input-placeholder,
.input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.input:focus::-moz-placeholder,
.input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.input:focus:-ms-input-placeholder,
.input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.input:focus ~ label,
.input:not(.empty) ~ label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-21px);
  cursor: default;
}

.input:focus ~ label {
  color: #24b47e;
}

.input.invalid ~ label {
  color: #ffa27b;
}

.input:focus ~ label ~ .baseline {
  background-color: #24b47e;
}

.input:focus.invalid ~ label ~ .baseline {
  background-color: #e25950;
}

input {
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.StripeElement--webkit-autofill {
  background: transparent !important;
}

input {
  -webkit-animation: 1ms void-animation-out;
}

.info {
  position: absolute;
  bottom: -17px;
  font-size: 10px;
  white-space: nowrap;
  display: none;

  &.error {
    color: red;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/npos/account/Profile.vue